<template>
  <div className="qrcode-page">
    <h1>您的二维码</h1>
    <canvas ref="canvasRef" width="200" height="200"></canvas> <!-- 使用 canvasRef 作为 ref 名称 -->
  </div>
</template>

<script>
import QRCode from 'qrcode';
import {onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';

export default {
  name: 'QRCodePage',
  setup() {
    const route = useRoute();
    const canvasRef = ref(null); // 创建对 canvas 元素的引用
    const subCategory = route.query.subCategory || ''; // 从路由获取 `subCategory` 参数
    const shopName = route.query.shopName || '';
    const industry = route.query.industry || '';

    // 生成二维码
    const generateQRCode = () => {
      const targetUrl = `${window.location.origin}/customer-review?industry=${encodeURIComponent(industry)}&subCategory=${encodeURIComponent(subCategory)}&shopName=${encodeURIComponent(shopName)}`;
      console.log(targetUrl)
      QRCode.toCanvas(canvasRef.value, targetUrl, (error) => { // 使用 canvasRef.value
        if (error) {
          console.error('二维码生成失败:', error);
        } else {
          console.log('二维码生成成功');
        }
      });
    };

    // 在组件加载后生成二维码
    onMounted(generateQRCode);

    return {
      canvasRef, // 返回 canvasRef，以便在模板中绑定
    };
  },
};
</script>

<style scoped>
.qrcode-page {
  max-width: 400px;
  margin: auto;
  text-align: center;
  padding: 30px;
}

canvas {
  border: 1px solid #ccc;
  margin-top: 20px;
}
</style>
